(function () {
  function bindSizeguideModal(dialog, root) {
    if (dialog.dataset.nestiSizeguideBound === 'true') {
      return;
    }

    const trigger = root.querySelector(`[aria-controls="${dialog.id}"]`);
    if (!trigger) {
      return;
    }

    dialog.dataset.nestiSizeguideBound = 'true';

    const closeButton = dialog.querySelector('[data-nesti-sizeguide-close]');

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        dialog.close();
      });
    }

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function initSizeguideModals(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nesti-sizeguide-modal]').forEach((dialog) => {
      bindSizeguideModal(dialog, scope === document ? document : scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSizeguideModals(document));
  } else {
    initSizeguideModals(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSizeguideModals(event.target);
  });
})();
